import { useEffect } from "react";
import { usePrefetch } from "@design-lab/app/usePrefetch";
import { PRODUCT_LIST_PATH } from "@design-lab/shared/constants/constants";
import { trackDesignLabSessionStart } from "@design-lab/shared/lib/analytics";
import { CompositionFormProvider } from "@design-lab/entities/composition";
import { DtfChannelProvider } from "@design-lab/shared/hooks/useDtfChannel";
import { DtfSideTrackingProvider } from "@design-lab/shared/hooks/useDtfSideTracking";
import { ProviderComposer } from "@design-lab/shared/lib/ProviderComposer";
import { ArtworkFormProvider, ArtworkProvider } from "@design-lab/entities/artwork";
import { DesignProjectSyncProvider } from "@design-lab/features/design-project";
import { DesignLabPage } from "@design-lab/pages/design-lab/DesignLabPage";

/**
 * Renders the Design Lab route and composes required providers for the page.
 *
 * Triggers a prefetch of the product list, refreshes delivery dates when addresses update,
 * and records the Design Lab session start on mount. Wraps the DesignLabPage with the
 * configured provider chain.
 *
 * @returns A JSX element that renders the Design Lab page wrapped by its providers.
 */
export function DesignLabRoute() {
  // Prefetch the product list page
  usePrefetch(PRODUCT_LIST_PATH);

  useEffect(() => {
    trackDesignLabSessionStart();
  }, []);

  const providers = [
    DtfChannelProvider,
    DtfSideTrackingProvider,
    CompositionFormProvider,
    ArtworkFormProvider,
    ArtworkProvider,
    DesignProjectSyncProvider
  ];

  return (
    <ProviderComposer providers={providers}>
      <DesignLabPage />
    </ProviderComposer>
  );
}
